module.exports = __webpack_public_path__ + "static/media/ox-logo.25b8d7ce.png";